/** @file Header button that opens the export dialog (EditorFrame passes it to ShellHeader as an action). */
import type { Translate } from '@pose2d/i18n/types';
import { exportDialogStore } from './exportDialogStore';

/** The same action as the export.open binding. */
export function ExportButton({ t }: { t: Translate }) {
  return <button type="button" onClick={() => { exportDialogStore.setState({ open: true }); }}>{t('exportDialog.open')}</button>;
}
